import React from 'react'

function MainBestPractices() {
    return (
        <div className="bg-white shadow-lg p-4 rounded-sm">
            <p className="text-3xl font-medium mt-2">
                How To Best Use Bound 🚀
            </p>
            <div className="mt-10 p-3 hover:shadow-lg border-4 border-gray-200 rounded-lg">
            <p className="text-xl mt-4 font-medium">
                1. Personalize on Relevant Personal Interests 🏀
            </p>
            <p className="my-4 text-base">
                Bound works best when personalizing on personal interests like <i>"Basketball, Likes Exploring, Baking, etc"</i>. When it's a personal interest Bound does a good job of being able to take their interest and tie it back into your companies pain and value prop to create a relevant message for your prospect. These are the types of messages that most of our users see the best response with.
            </p>
            </div>
            <div className="mt-4 p-3 hover:shadow-lg border-4 border-gray-200 rounded-lg">
            <p className="mt-4 text-xl font-medium">
                2. Use Custom Topic For Topics You Find 💌
            </p>
            <p className="my-4 text-base">
            Found something on the prospects twitter, or elsewhere that you would like to reference in a message? Use the Custom Topic input to put in a topic for Bound to write about.
            </p>
            </div>
            <div className="mt-4 p-3 hover:shadow-lg border-4 border-gray-200 rounded-lg">
            <p className="mt-4 text-xl font-medium">
                3. Save Messages That You Like So Bound Can Learn 🧠
            </p>
            <p className="my-4 text-base">
            Whenever you save or copy a message, you're telling Bound the types of messages you would like to see more of. Whenever you have a message you really like, click save so that Bound can try to create more of those messages for you.
            </p>
            </div>
            <div className="mt-4 p-3 hover:shadow-lg border-4 border-gray-200 rounded-lg">
            <p className="mt-4 text-xl font-medium">
                4. Use Built In Hotkeys To Prospect Faster 💨
            </p>
            <p className="my-4 text-base">
                <li>
                Need to Copy a message? Just click <b>'c'</b> on your keyboard.
                </li>
                <li>
                Need to Generate a message? Just click <b>'g'</b> on your keyboard.
                </li>
                <li>
                Need to go to a prospects Linkedin? Just click <b>'l'</b> on your keyboard.
                </li>
                <li>
                Need to Save a message? Just click <b>'s'</b> on your keyboard.
                </li>
            </p>
            </div>
        </div>
    )
}

export default MainBestPractices
